import React from 'react';
import { usePermission } from '@/contexts/PermissionContext';
import type { Permission } from '@/types/api';

interface PermissionWrapperProps {
  children: React.ReactNode;
  permission: Permission | Permission[];
  mode?: 'all' | 'any'; // 'all' 表示需要所有权限，'any' 表示需要任一权限
  fallback?: React.ReactNode;
}

/**
 * 权限包装组件
 * 根据用户权限决定是否显示子组件
 */
const PermissionWrapper: React.FC<PermissionWrapperProps> = ({
  children,
  permission,
  mode = 'any',
  fallback = null,
}) => {
  const { hasPermission, hasAnyPermission, hasAllPermissions } = usePermission();

  let hasAccess = false;

  if (Array.isArray(permission)) {
    hasAccess = mode === 'all' 
      ? hasAllPermissions(permission)
      : hasAnyPermission(permission);
  } else {
    hasAccess = hasPermission(permission);
  }

  return hasAccess ? <>{children}</> : <>{fallback}</>;
};

export default PermissionWrapper;

